import React, { useEffect, useState } from "react";
import { Dropdown, Table, Form, Button, Icon, Input } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import moment from "moment";
import _ from "lodash";
import { PracticeList } from "../../model/practice";
import { useActions } from "../../redux/actions";
import * as referralActions from "../../redux/actions/referrals";
import { ReferalExt } from "../../model/referral";
import "react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css";
import PatientInsight from "../PatientInsight";
import PatientCallLog from "../PatientCallLog";
import { StatusType } from "../../model/StatusType";
import * as statusActions from "../../redux/actions/oralSurgeryStatuses";
import { aptStatus } from "../../constants";
import { capitalizeFirstLetter } from "../../utils/common";

interface Props {
  detailsModal: any;
  reportData: any;
  practiceList: any;
  openFamilyView?: Function;
  statuses: any;
  auth: any;
}

interface SetupData {
  confirm: boolean;
  deleteId: any;
  type: any;
  editItem: any;
  column: any;
  data: any;
  direction: any;
}

const ReferralOutTableData: React.FC<Props> = (props) => {
  let initialState: SetupData = {
    data: props.reportData,
    confirm: false,
    deleteId: false,
    type: false,
    editItem: false,
    column: null,
    direction: null,
  };
  const [state, setStates] = useState(initialState);
  const referralAction = useActions(referralActions);
  const StatusActions = useActions(statusActions);
  const [oralSurgeryStatus, setOralSurgeryStatus] = useState([]);

  useEffect(() => {
    StatusActions.fetchOralSurgeryStatus().then((res: any) => {
      setOralSurgeryStatus(res);
    });
  }, []);

  let changeMachine: any[] = [];
  const gotoUDR = (item: any) => {
    const { Practice, PatNum } = item;
    if (props.openFamilyView) props.openFamilyView(PatNum, Practice, Practice);
  };

  const gotoRefIn = (item: any, practice: number) => {
    const { refInPractice, refInPatId } = item;

    if (props.openFamilyView) {
      if (practice === 1) {
        props.openFamilyView(refInPatId, refInPractice, refInPractice);
      }
    }
  };

  const handleSort = (clickedColumn: any) => () => {
    const { column, data, direction } = state;
    if (column !== clickedColumn) {
      setStates({
        ...state,
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: "ascending",
      });
      return;
    }

    setStates({
      ...state,
      data: data.reverse(),
      direction: direction === "ascending" ? "descending" : "ascending",
    });
  };

  const onChange = (e: any) => {
    let editItem = state.editItem;
    editItem[e.target.name] = e.target.value;
    setStates({ ...state, editItem });
  };

  const updateItemInState = () => {
      let editItem = {...state.editItem};
      const newState = { ...state };
      const indexOfItem = newState.data.findIndex((item: any) => item.PatNum_Date === editItem.PatNum_Date);
      if (indexOfItem !== -1) {
        newState.data[indexOfItem] = editItem;
        newState.editItem = false;
      }
      setStates(newState);
  }

  const onChangeDrop = (e: any, a: any) => {
    let editItem = state.editItem;
    editItem[a.name] = a.value;
    setStates({ ...state, editItem });
  };

  const onChangeDate = (event: any, data: any) => {
    let editItem = state.editItem;
    editItem[event] = data;
    setStates({ ...state, editItem });
  };
  
  const getValueOrDefault = (value: any | undefined | null, defaultValue: any) => {
    return value === undefined || value === null ? defaultValue : value;
  };

  const submitEdit = () => {
    let obj: ReferalExt = {
        ...state.editItem,
      PatNum_Date: state.editItem.PatNum_Date,
      speciality: getValueOrDefault(state.editItem.speciality, undefined) ?? getValueOrDefault(state.editItem.type?.find((f: any) => f), ""),
      refOutPractice: getValueOrDefault(state.editItem.Practice, ""),
      refOutDate: getValueOrDefault(state.editItem.refOutDate, null),
      refOutPatId: getValueOrDefault(state.editItem.PatNum, ""),
      refInPractice: getValueOrDefault(state.editItem.refInPractice, ""),
      refInPatId: getValueOrDefault(state.editItem.refInPatId, ""),
      aptDate: getValueOrDefault(state.editItem.aptDate, null),
      aptStatus: getValueOrDefault(state.editItem.aptStatus, ""),
      callLog: getValueOrDefault(state.editItem.callLog, ""),
      insights: getValueOrDefault(state.editItem.insights, ""),
      care: getValueOrDefault(state.editItem.care, 0),
      statusId: getValueOrDefault(state.editItem.statusId, ""),
    };
    referralAction.saveReferalsExt(obj);
    changeMachine.push(obj);
    updateItemInState();
  };

  const handleEdit = (item: any) => {
    const newItem = { ...item };
    const isValidDate = moment(newItem.refOutDate, moment.ISO_8601, true).isValid();

    newItem.refOutDate = isValidDate ? new Date(newItem.refOutDate) : new Date();

    setStates({ ...state, editItem: newItem });
  };

  const practiceOptionsEdit = props.practiceList.map((practice: any) => ({
    key: practice.id,
    value: practice.practice,
    text: practice.practice,
  }));

  const submitChange = (editItem: any) => {
    let updateObj = {...editItem} as any;
    const fields = [
      "PatNum_Date",
      "speciality",
      "refOutPractice",
      "refOutDate",
      "refInPractice",
      "refOutDate",
      "aptStatus",
      "callLog",
      "insights",
      "care",
      "refInPatId",
      "statusId",
    ];
    fields.forEach(
      (field: string) =>
        (updateObj[field] = editItem[field] !== null && editItem[field] !== "" ? editItem[field] : undefined)
    );
    referralAction.saveReferalsExt(updateObj);
    updateItemInState();
  };

  const updateUserInfo = (patientCallLog: any, dataKey: number, PatNum_Date: string, stateLog: any) => {
    const { data } = state;
    let editItem: any = Object.keys(data).find((x: any) => x.PatNum_Date === PatNum_Date);
    const StatusId = Object.assign({}, editItem);
    editItem.key = dataKey;
    editItem.user = props.auth.user.username;
    editItem.note = patientCallLog.notes;
    editItem.refInPatId = stateLog.referInPatientNumber;
    editItem.statusId = stateLog.statusId;
    editItem.refInPractice = stateLog.refInPractice;
    setStates({ ...state, editItem });
    if (StatusId.statusId !== editItem.statusId || StatusId.refInPractice !== editItem.refInPractice) {
      submitChange(editItem);
    }
  };

  const getStatusX = (id: number | undefined | null, type: string) => {
    let statusInfo: { statusColor: string; referStatus: string } | undefined;
    let defaultStatusInfo: { statusColor: string; referStatus: string } = { statusColor: "", referStatus: "" };

    if (type === "refIn") {
      const statuses: any[] = Object.values(oralSurgeryStatus);
      statusInfo = statuses.find((item: any) => item.id === id);
      const defaultStatus = statuses.find((item: any) => item.referStatus?.toLowerCase().trim() === "not started");
      if (defaultStatus) {
        defaultStatusInfo = defaultStatus;
      }
    } else {
      // 'refOut'
      statusInfo = aptStatus.find((statusType: StatusType) => statusType.id === id);
      const defaultStatus = aptStatus.find((statusType: StatusType) => statusType.id === 0);
      if (defaultStatus) {
        defaultStatusInfo = defaultStatus;
      }
    }

    const finalStatus = id === undefined || id === null ? defaultStatusInfo : statusInfo || defaultStatusInfo;

    return (
      <div className="roundedButton" style={{ background: finalStatus.statusColor }}>
        <div className="roundedButtonText">{finalStatus.referStatus}</div>
      </div>
    );
  };


  const dropDownStatus = (type: any) => {
      const filterType = (item: any) => item.type && Array.isArray(type) ? type.includes(item.type) : item.type === type;

    return oralSurgeryStatus.filter(filterType)
      .map((item: any) => ({
        key: item.id,
        value: item.id,
        text: item.referStatus,
      }));
  };

  const getHeader = (detailsModal: any) => {
    const { column, direction } = state;
    const directionIcon = direction === "ascending" ? "up" : "down";

    const baseHeaders = [
      { title: "R-Out Practice", sortKey: "practice" },
      { title: "R-Out Pat #", sortKey: "patientId" },
      { title: "F.Name" },
      { title: "L.Name" },
      { title: "Contact #" },
      { title: "Ref-In Practice", sortKey: "refInPractice", style: { minWidth: "150px" } },
      { title: "Ref-In Pat #", sortKey: "patientIdI", style: { minWidth: "150px" } },
      { title: "Status", sortKey: "status", style: { minWidth: "150px" } },
    ];

    const detailHeaders: { title: string; sortKey?: string; style?: any }[] = [
      { title: "Speciality" },
      { title: "Send Date" },
      { title: "Apt Date" },
      { title: "Apt Status", sortKey: "aptStatus" },
      { title: "Procedure Category" },
      { title: "Call Log" },
      { title: "Insights" },
      { title: "Care" },
      { title: "External Referral" },
    ];

    const headers =
      detailsModal === "report" ? [...baseHeaders, { title: "" }] : [...baseHeaders, ...detailHeaders, { title: "" }];

    return (
      <Table.Row>
        {headers.map((header, index) => (
          <Table.HeaderCell
            key={index}
            className={header.sortKey ? `cursorPointer ${column === header.sortKey ? "active" : ""}` : ""}
            onClick={header.sortKey ? handleSort(header.sortKey) : undefined}
          >
            {header.sortKey ? (
              <span>
                {header.title}
                <i className={`sort amount ${directionIcon} icon ml-05`}/>
              </span>
            ) : (
              header.title
            )}
          </Table.HeaderCell>
        ))}
      </Table.Row>
    );
  };

  const renderActionButtons = (item: any) => {
    if (state.editItem && state.editItem.PatNum_Date === item.PatNum_Date) {
      return (
        <Button.Group size="tiny">
          <Button icon="save" color="orange" onClick={submitEdit}/>
          <Button icon="cancel" secondary={true} onClick={() => setStates({ ...state, editItem: false })}/>
        </Button.Group>
      );
    }
    return (
      <span className="mb10">
        <Icon name="edit" className="mr15 cursorPointer" onClick={() => handleEdit(item)} />
      </span>
    );
  };

  const renderReportRow = (item: any, key: number) => (
    <Table.Row key={key}>
      <Table.Cell>{item.practice}</Table.Cell>
      <Table.Cell className="primaryColor cursorPointer" onClick={() => gotoUDR(item)}>
        {item.patientId}
      </Table.Cell>
      <Table.Cell>{item.PatFName}</Table.Cell>
      <Table.Cell>{item.PatLName}</Table.Cell>
      <Table.Cell>{item.WirelessPhone}</Table.Cell>
      <Table.Cell>
        {state.editItem && state.editItem.PatNum_Date === item.PatNum_Date ? (
            <Dropdown
              search={true}
              style={{ minWidth: "150px" }}
              options={
                props.practiceList
                  ? [
                      {
                        key: "All",
                        value: "All",
                        text: "All",
                      },
                      ...props.practiceList.map((practice: PracticeList) => ({
                        key: practice.id,
                        value: practice.practice,
                        text: practice.practice,
                      })),
                    ]
                  : []
              }
              name="refInPractice"
              fluid={true}
              selection={true}
              placeholder="Select Practice"
              onChange={(e, a) => onChangeDrop(e, a)}
              defaultValue={state.editItem.refInPractice}
            />
        ) : (
          item.refInPractice
        )}
      </Table.Cell>
      <Table.Cell>
        {state.editItem && state.editItem.PatNum_Date === item.PatNum_Date ? (
          <Form.Field>
            <Input
              name="refInPatId"
              fluid={true}
              placeholder="Patient #"
              onChange={(e) => onChange(e)}
              defaultValue={state.editItem.refInPatId}
            />
          </Form.Field>
        ) : (
          <div className="primaryColor cursorPointer" onClick={() => gotoRefIn(item, 1)}>
            {item.refInPatId}
          </div>
        )}
      </Table.Cell>
      <Table.Cell>
        {state.editItem && state.editItem.PatNum_Date === item.PatNum_Date ? (
          <Dropdown
            search={true}
            name="statusId"
            placeholder="Status"
            fluid={true}
            selection={true}
            options={dropDownStatus(item.type)}
            style={{ minWidth: "150px" }}
            onChange={(e, a) => onChangeDrop(e, a)}
          />
        ) : (
          getStatusX(item.statusId, "refIn")
        )}
      </Table.Cell>
      <Table.Cell>{renderActionButtons(item)}</Table.Cell>
    </Table.Row>
  );

  const renderDetailRow = (item: any, key: number) => {
    const options = dropDownStatus(item.speciality);
    return (
      <Table.Row key={key}>
        <Table.Cell className="table-col-sticky">{capitalizeFirstLetter(item.practice)}</Table.Cell>
        <Table.Cell>{item.patientId}</Table.Cell>
        <Table.Cell>{item.PatFName}</Table.Cell>
        <Table.Cell>{item.PatLName}</Table.Cell>
          <Table.Cell>{item.WirelessPhone}</Table.Cell>
        <Table.Cell>
          {state.editItem && state.editItem.PatNum_Date === item.PatNum_Date ? (
            <Form.Field>
              <Dropdown
                style={{ minWidth: "70px" }}
                options={practiceOptionsEdit}
                name="refInPractice"
                fluid={true}
                single={true}
                selection={true}
                placeholder="Select Practice"
                onChange={(e, a) => onChangeDrop(e, a)}
                defaultValue={state.editItem.refInPractice}
              />
            </Form.Field>
          ) : (
            item.refInPractice
          )}
        </Table.Cell>
        <Table.Cell>
          {state.editItem && state.editItem.PatNum_Date === item.PatNum_Date ? (
            <Form.Field>
              <Input
                style={{ minWidth: "70px" }}
                name="refInPatId"
                fluid={true}
                placeholder="Patient #"
                onChange={(e) => onChange(e)}
                defaultValue={state.editItem.refInPatId}
              />
            </Form.Field>
          ) : (
            item.refInPatId
          )}
        </Table.Cell>
        <Table.Cell>
          {state.editItem && state.editItem.PatNum_Date === item.PatNum_Date ? (
            <Dropdown
              search={true}
              className="mr10 mb15"
              name="statusId"
              placeholder="Status"
              selection={true}
              options={dropDownStatus(item.speciality)}
              onChange={(e, a) => onChangeDrop(e, a)}
            />
          ) : (
            getStatusX(item.statusId, "refIn")
          )}
        </Table.Cell>
        <Table.Cell>{item.speciality === "oral" ? "Oral Surgery" : "Ortho"}</Table.Cell>
        <Table.Cell>{item.dateOfService}</Table.Cell>
        <Table.Cell>
          {state.editItem && state.editItem.PatNum_Date === item.PatNum_Date ? (
            <Form>
              <Form.Field className="mw-120">
                <DatePicker
                  selected={state.editItem.refOutDate}
                  dateFormat="yyyy-MM-dd"
                  onChange={(date) => onChangeDate("refOutDate", date)}
                />
              </Form.Field>
            </Form>
          ) : item.refOutDate ? (
            moment(item.refOutDate).format("MM-DD-YYYY")
          ) : (
            item.refOutDate
          )}
        </Table.Cell>
        <Table.Cell>{getStatusX(item.aptStatus, "refOut")}</Table.Cell>
        <Table.Cell>{item.procat}</Table.Cell>
        <Table.Cell>
          <PatientCallLog
            patientId={item.PatNum}
            refInPatId={item.refInPatId}
            practice={item.Practice}
            speciality={item.speciality}
            updateUserInfo={updateUserInfo}
            dropDownStatus={options}
            practiceOptionsEdit={practiceOptionsEdit}
            statusId={item.statusId}
            dataKey={key}
            PatNum_Date={item.PatNum_Date}
            refInPractice={item.refInPractice}
          />
        </Table.Cell>
        <Table.Cell>
          <PatientInsight patientId={item.PatNum} practice={item.Practice} />
        </Table.Cell>
        <Table.Cell/>
        <Table.Cell>{item.External_Referral ?? ""}</Table.Cell>
        <Table.Cell className="pb0">{renderActionButtons(item)}</Table.Cell>
      </Table.Row>
    );
  };

  const getTableRows = (detailsModal: any) => {
    const { data } = state;

    if (!data || !data.length) {
      const colSpan = detailsModal === "report" ? 9 : 19;
      return (
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan={colSpan} textAlign="center">
              No Record Found
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      );
    }

    const renderFunction = detailsModal === "report" ? renderReportRow : renderDetailRow;

    return <Table.Body>{data.map(renderFunction)}</Table.Body>;
  };

  return (
    <Table striped={true} compact={true}>
      <Table.Header>{getHeader(props.detailsModal)}</Table.Header>
      {props.detailsModal && getTableRows(props.detailsModal)}
    </Table>
  );
};

export default ReferralOutTableData;
